import "../banner/Banner.css"

function Banner() {
  return (
    <div >
      <img className="banner-home" src="../assets/thumbnail_BANNER_SITE.jpeg" alt="Banner" />
    </div>
  )
}

export default Banner;